import { apiClient } from './client.js';
import { API_ENDPOINTS } from '../config/constants.js';
import { setAuthToken, removeAuthToken } from '../storage/token.js';
import type { AuthToken, User } from '../models/user.js';

export async function getToken(username?: string, password?: string, remember = true): Promise<AuthToken> {
  const response = await apiClient.post<AuthToken>(
    API_ENDPOINTS.USER_TOKEN,
    username && password ? { email: username, password } : undefined
  );
  
  if (response?.token) {
    setAuthToken(response, remember);
    return response;
  }
  
  throw new Error('Failed to get token');
}

export async function exchangeMagicToken(magicToken: string, remember = true): Promise<AuthToken> {
  if (!magicToken.trim()) {
    throw new Error('Magic token is required');
  }

  const response = await apiClient.post<AuthToken>(
    API_ENDPOINTS.USER_EXCHANGE_TOKEN,
    { magic_token: magicToken }
  );

  if (response?.token) {
    setAuthToken(response, remember);
    return response;
  }

  throw new Error('Failed to exchange magic token');
}

export async function getUserProfile(): Promise<User> {
  const response = await apiClient.get<User>(
    API_ENDPOINTS.USER_PROFILE,
    { withAuth: true }
  );
  
  if (response) {
    return response;
  }
  
  throw new Error('Failed to get user profile');
}

export function logout(): void {
  removeAuthToken();
} 